import { AutoAwesome as SparklesIcon } from '@mui/icons-material';

export default function AiIcon(props) {
  return <SparklesIcon sx={{ color: '#FFD700' }} {...props} />;
}
